// @flow
// Main section height ratios
export const heightRatios = {
    CONTROL_PANEL: 0.09,
    TIME_AXIS: 0.07,
    WEEK: 0.84
};

export const MIN_WIDTH = 320; // the minimum width supported by the schedule
export const SIDE_MARGIN_WIDTH = 30;
export const SLIDER_HEIGHT = 30;
export const SLIDER_Y = 80; // distance between the selecetd event and the slider

export const OPACITY_LEVEL = 0.25;

export const DURATION = '0.3s';
export const EASING = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
export const TRANSITION_DEF = `all ${DURATION} ${EASING}`;

// events
export const EVENT_SIDE_MARGIN = 2;
export const EVENT_HEIGHT_MARGIN_RATIO = 0.15;

// svg definitions
export const dualColorGradiant = 'dualColorGradiant';



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/constants.js